import type { z } from 'zod';

import {
  createFindManyAiToolInputSchema,
  namedItemFilterFieldMappings,
} from '@erikdakoda/ai-tool/findManyAiToolInput';
import {
  BOT_AI_TOOL_FILTER_FIELDS,
  BOT_AI_TOOL_SEARCH_SCALAR_FIELDS,
  BOT_AI_TOOL_SORTABLE_FIELDS,
} from '../shared/botAiToolQueryInput';

const botFilterFieldMappingsLocal = {
  ...namedItemFilterFieldMappings,
  id: { path: ['id'], valueType: 'string' },
  description: { path: ['description'], valueType: 'string' },
  group: { path: ['group'], valueType: 'string' },
  handle: { path: ['handle'], valueType: 'string' },
  integration: { path: ['integration'], valueType: 'enum' },
  modelName: { path: ['modelName'], valueType: 'string' },
  useCase: { path: ['useCase'], valueType: 'string' },
} as const;

export const botFilterFieldMappings = botFilterFieldMappingsLocal;

export const findBotsInputSchema = createFindManyAiToolInputSchema({
  filterableFields: BOT_AI_TOOL_FILTER_FIELDS,
  filterFieldMappings: botFilterFieldMappingsLocal,
  sortableFields: BOT_AI_TOOL_SORTABLE_FIELDS,
  selectableScalars: BOT_AI_TOOL_SEARCH_SCALAR_FIELDS,
});

export type FindBotsInput = z.infer<typeof findBotsInputSchema>;
